<section
  [id]="banner()?.sectionId"
  [class]="banner()?.sectionStyleClass"
  class="scroller-container"
  [ngClass]="{
    'hide-on-mobile-view': !banner()?.advanceConfiguration?.sectionVisibility.mobile,
    'hide-on-desktop-view': !banner()?.advanceConfiguration?.sectionVisibility.desktop
  }"
>
  <div class="det-default-scrolling-text-container editable">
    <span
      class="det-text-customizable-scrolling-text editable"
      [ngClass]="{
        paused: !banner()?.mainConfiguration.isAnimationRunning,
        'left-to-right':
          banner()?.mainConfiguration.scrollDirection === ScrollDirection.leftToRight,
        'right-to-left': banner()?.mainConfiguration.scrollDirection === ScrollDirection.rightToLeft
      }"
      [ngStyle]="{
        'animation-duration': banner()?.mainConfiguration.animationSpeed + 's'
      }"
      id="scrollingText"
    >
      {{ banner()?.mainConfiguration.textContents.scrollingText }}
    </span>
  </div>
</section>
